import { render, staticRenderFns } from "./CommunicationChannels.vue?vue&type=template&id=2e6dd319&scoped=true&"
import script from "./CommunicationChannels.vue?vue&type=script&lang=js&"
export * from "./CommunicationChannels.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationChannels.vue?vue&type=style&index=0&id=2e6dd319&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6dd319",
  null
  
)

export default component.exports